import { db } from '../Index';
import { isRegister } from './IsRegister';

export const GetLocalRegisters = async (
  animalId: string,
  filters: any,
  limit: number,
) => {
  const registers = await db.registros.where({ animal_id: animalId }).toArray();

  let toPerformData = await db.toPerform.toArray();
  toPerformData.filter(item => isRegister(item.data));

  const registersToPerform = toPerformData.map(item => {
    return {
      ...item.data,
      id: item.id,
      created_at: item.created_at,
    };
  });

  let allRegisters = registers.concat(registersToPerform);
  allRegisters.sort(sortByDate);

  allRegisters = FilterArray(allRegisters, filters);

  if (limit === 1) {
    return [allRegisters.find(i => i.id === filters.id)];
  }

  if (allRegisters.length > limit) {
    allRegisters.length = limit;
  }

  return allRegisters;
};

const sortByDate = (a: any, b: any) => {
  const dateA = new Date(a.data).getTime();
  const dateB = new Date(b.data).getTime();
  return dateA < dateB ? 1 : -1;
};

function FilterArray(array: any[], filters: any) {
  const filtered = array.filter((item: any) => {
    const keys = Object.keys(filters);
    let matches = false;

    keys.some(key => {
      matches = item[key] === filters[key];

      if (!matches) {
        return true;
      }
    });

    if (matches) {
      return item;
    }
  });

  return filtered;
}
